import { connect                                                        } from 'react-redux'              ;
import { getInitApplicationState, getActiveChannelId                    } from '../reducers/gui'          ;
import { getConfig, getS5Alias,  getLanguage, getFocusMatchId           } from '../reducers/config'       ;
import { getStaticText,                                                 } from '../reducers/staticTexts'  ;
import { getTranslations                                                } from '../reducers/translations' ;
import { getMatchIdByChannelId, getLastServerHeaderTimestampMs          } from '../reducers/timings'      ;
import { getSeasonId, getUniqueTournamentId                                   } from '../reducers/matches'      ;
import { getStatisticCenterBaseUrl                                      } from '../reducers/bookmakerOptions';
import Layout from '../presentations/Layouts/Layout';

const mapStateToProps = ( state: any ) => {
    const date = new Date( getLastServerHeaderTimestampMs( state ) )
    
    const serverTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    return (
        {
            // map the layout via layout name from the config to the props
            isApplicationReady:     getInitApplicationState( state ),
            layoutName:             getConfig( state ).layout,
            staticTexts:            getStaticText( state ),
            translations:           getTranslations( state ),
            seasonid:               getSeasonId( state ),
            uniquetournamentid:     getUniqueTournamentId( state ),
            matchid:                getMatchIdByChannelId( state, getActiveChannelId( state ) ),
            statisticCenterBaseUrl: getStatisticCenterBaseUrl( state ),
            lang:                   getLanguage( state ),
            serverTime:             serverTime,
            s5Alias:                getS5Alias( state ),
            focusmatchid:           getFocusMatchId( state )
        }
    )
}

export default connect( mapStateToProps, null )( Layout );
